<template>
  <div class="project">
    <div class="container custom">
      <div class="project__title" data-aos="fade-up">Our Projects</div>
      <div class="project__grid">
        <template v-for="(item, index) in listproject">
          <template v-if="item.externalLink">
            <a :href="item.link" class="project__grid-item" :data-aos="item.effect" :key="index">
              <div class="item__image">
                <img :src="`/assets/images/project/${item.image}`" alt="item">
              </div>
              <div class="item__content">
                <div class="item__content-title">{{ item.title }}</div>
                <div class="item__content-text" v-html="item.text"></div>
              </div>
            </a>
          </template>
          <template v-else>
            <router-link :to="{ path: item.link }" class="project__grid-item" :data-aos="item.effect" :key="index">
              <div class="item__image">
                <img :src="`/assets/images/project/${item.image}`" alt="item">
              </div>
              <div class="item__content">
                <div class="item__content-title">{{ item.title }}</div>
                <div class="item__content-text" v-html="item.text"></div>
              </div>
            </router-link>
          </template>
        </template>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      listproject: [
        { link: 'timestore', image: 'grid-item-01.png', title: 'Time Store', text: `Cashless sale solution by <br> applying Blockchain technology`, effect: 'fade-right' },
        { link: 'portal-api-services', image: 'grid-item-02.png', title: 'Portal API Services', text: `The portal to access to top-notch <br> technologies and solutions`, effect: 'fade-down' },
        { link: 'explorer', image: 'grid-item-03.png', title: 'Explorer', text: `“Blockchain window” satisfies <br> traders’ need for transparency`, effect: 'fade-left' },
        { link: 'timebit-defi', image: 'grid-item-04.png', title: 'Timebit Defi', text: `A new generation wallet for a new <br> generation of traders and investors`, effect: 'fade-right' },
        { link: 'timebird-exchange', image: 'grid-item-05.png', title: 'TimeBird Exchange', text: `A crypto exchange fiiting to <br> diversified projects`, effect: 'fade' },
        { link: 'timebird-ekyc', image: 'grid-item-06.png', title: 'TimeBird eKYC', text: `Electronic Know-Your-Customer`, effect: 'fade-left' },
        { link: 'timebird-trade', image: 'grid-item-07.png', title: 'TimeBird Trade', text: `Discover, collect, & sell extraordinary NFTs`, effect: 'fade-right' },
        { link: 'tbc-scan', image: 'grid-item-08.png', title: 'TBC Scan', text: `TBC Scan is a Block Explorer and Analytics Platform for TBC Network`, effect: 'fade-up' },
      ]
    }
  },
  created() {
    setTimeout(() => {
      AOS.refreshHard()
    }, 100)
  }
}
</script>
